/**
 * 系统-资源管理（BaseAdminResourceController）
 */
import { addResourceDialog, editResourceDialog, resourceTypeColumnFormatter } from './_dialogs'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import { buildResourceTree } from '@/utils'
import { commonOptions } from '@/config'


export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/base_user/admin/resource/list',
        requestTransform: (req: any, action: any) => {
          action.currentParams = req || {}
          return req
        },
        responseTransform: (res: any, action: any) => {
          const { resourceName, resourceCode } = action?.currentParams || {}
          // 有搜索项不够尖树
          if (resourceName || resourceCode) {
            return res || []
          }
          const tree = buildResourceTree(res)
          return tree || []
        }
      },
      add: {
        label: '添加资源',
        api: '/base_user/admin/resource/create',
        dialog: addResourceDialog(),
        successMessage: '新增成功'
      },
      edit: {
        label: '编辑',
        api: '/base_user/admin/resource/update',
        dialog: editResourceDialog(),
        successMessage: '保存成功'
      },
      delete: {
        label: '删除',
        api: '/base_user/admin/resource/deleteResourceTree',
        payload: {
          id: '${data.row.id}'
        },
        message:
          '确认删除该资源（将删除所有层级的子节点数据）？若已被角色引用，删除后可能影响权限配置，请谨慎操作。'
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 100,
      items: [
        { type: 'input', prop: 'resourceName', label: '资源名称', span: 6 },
        { type: 'input', prop: 'resourceCode', label: '资源编码', span: 6 }
      ]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }]
    },
    table: {
      tree: {
        // lazy: false
        // parentProp: 'parentCode',
        // rowKey: 'resourceCode'
      },
      innerAttrs: {
        noIndex: true,
        noPager: true,
        rowKey: 'resourceCode',
        defaultExpandAll: false,
        treeProps: { children: 'children', hasChildren: 'hasChildren' }
      },

      operation: {
        width: 200,
        position: 'left',
        items: [
          {
            action: 'edit',
            // visibleOn: 'this.data.row.__treeLevel > 1'
          },
          {
            action: 'delete',
            // visibleOn: 'this.data.row.__treeLevel > 1'
          }
        ]
      },
      columns: [
        {
          label: '资源级别',
          prop: 'resourceLevel',
          minWidth: 100,
          formatter: (row: any) => {
            return commonOptions.systemResourceLevels.find((it: any) => it.value === row.resourceLevel)?.label || '--'
          }
        },
        { label: '资源名称', prop: 'resourceName', minWidth: 160 },
        { label: '资源编码', prop: 'resourceCode', minWidth: 160 },
        {
          label: '资源类型',
          prop: 'resourceType',
          minWidth: 100,
          formatter: resourceTypeColumnFormatter
        },
        { label: '父级资源', prop: 'parentName', minWidth: 120 },
        { label: '排序', prop: 'sortNum', minWidth: 80 }
      ]
    }
  }
}
